import React, {Component} from 'react';
//import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';
import DealerContainer from './DealerContainer';
import OrderbookContainer from './OrderbookContainer';
import TransactionSwitcher from './TransactionSwitcher';
import TotalStats from './TotalStats.js';
import Switcher from '../Charts/Switcher';
import '../../styles/stylesheets/screen.css';
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import * as firebase from 'firebase';
import {Steps} from 'intro.js-react';
import Link from "react-router-dom/es/Link";
import Button from "./Buttons";
import { withStyles } from 'material-ui/styles';
import Drawer from 'material-ui/Drawer';
import List from 'material-ui/List/List';
import ListItem from 'material-ui/List/ListItem';
import ListItemText from 'material-ui/List/ListItemText';
import ExpandLess from 'material-ui-icons/ExpandLess';
import ExpandMore from 'material-ui-icons/ExpandMore';
import Collapse from 'material-ui/transitions/Collapse';
import Paper from 'material-ui/Paper/Paper';
import userStore from '../../stores/UserStore';


const drawerWidth = "240px";


const styles = {
  shift: {
    marginLeft: '120px',
    marginRight: '-100px',
    marginTop: '-25px'
  },
  paper: {
    width: 'auto',
  },
  hide: {
    display: 'inline-block'
  }
};
const style = {
    width: 400,
    margin: 0,
    display: 'inline-block'
};

/**
 * This component acts as the simulationContainer for
 * all components of the simulation receives
 * user prop from app.js
 */
class simulationContainer extends Component {
    constructor(props) {
        //console.log("simulationContainer created");
        super(props);
        this.state = {
            renderplotly: false,
            showingStudents: false,
            studentsData:[],
            open:[],
            isReady: false,
            running: false,
            displayStats: {},
            isSessionAdmin: true
        };
        this.db = props.dbs[props.location.state.dbi].database().ref(props.institution);
        this.statListeners = [];
        console.log(props);
        setTimeout( ()=>{
          this.getPendingStudentsData();
        }, 1000);
    }

    /**
     * goes to ref StartSim/Ready and
     * sets the state of renderplotly
     */
    componentDidMount() {
        console.log("simulationContainer componentDidMount");
        userStore.setGame(this.props.location.state.sessionid);
        this.plotlyrenderRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child('StartSim').child("Ready");
        this.plotlyrenderRef.on('value', snap => {
            if (!!snap.val() && snap.val() === true) {
                this.setState({
                    renderplotly: true
                });
                this.plotlyrenderRef.off();
            } else {
                this.setState({
                    renderplotly: false
                });

            }
        })

        var timeRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("DisplayTime");
        timeRef.on("value", (ss)=>{
          var data = ss.val();
          if (!!data){
            this.props.updateTime(data);
          }
        });
        this.statListeners.push(timeRef);
    }

    toggleStudents(){
      this.setState({showingStudents: !this.state.showingStudents})
      console.log("student");
    }

    registerStats(key){
      let userStatRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("Users").child(key).child("Assets").child("INTC").child("Stats");
      let mRef = userStatRef.child("Mission");
      mRef.on("value", ss=>{
        let data = ss.val();
        if (!!data){
          let displayStats = Object.assign({}, this.state.displayStats);    //creating copy of stats
          displayStats[key].mission = data;
          this.setState({displayStats});
        }
      });
      this.statListeners.push(mRef);
      let sRef = userStatRef.child("Shares");
      sRef.on("value", ss=>{
        let data = ss.val();
        if (!!data){
          let displayStats = Object.assign({}, this.state.displayStats);    //creating copy of stats
          displayStats[key].shares = data;
          this.setState({displayStats});
        }
      });
      this.statListeners.push(sRef);
    }

    getPendingStudentsData() {
        // this.setState({
        //     studentsData:[]
        // })

        this.studentRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("UsersPending");
        //this.userRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("Users").child(this.props.uid).child("INTC").child("stats");
        this.studentRef.on('value', snap =>{
          let rawData = snap.val();
          //console.log("data of student " + rawData);
          let studentInfo;
          let students = [];
          let openstate = [];
          let displayStats = this.state.displayStats;
          for(var key in rawData){
            if (rawData[key].displayName){
                students.push(rawData[key]); //has .uid which == key too
                if (!displayStats.hasOwnProperty(key)){
                  displayStats[key] = {displayName: rawData[key].displayName, mission: "-", shares: "-"};
                  let that = this;
                  let uid = key;
                  setTimeout( ()=>{
                      that.registerStats(uid);
                  }, 0);
                }
            }
          }
          var len = students.length;
          for (var i=0;i<len;i++){
              var flag = false;
              openstate.push(flag);
          }
          this.setState({
              studentsData: students,
              openBuy: openstate,
              displayStats: displayStats
          });
          console.log("student data ", this.state.studentsData);
         // this.state.dataItemsSell = this.state.studentsDataSell.map((numbersSell) =><div>{numbersSell}</div>);
         // this.state.dataItemsBuy = this.state.studentsDataBuy.map((numbersBuy) =><li>{numbersBuy}</li>);
      })
    }

    startTutorial() {
        //console.log("simulationContainer startTutorial");
        this.setState({
            stepsEnabled: true
        })
    }

    handleStart() {
      this.setState({isReady: true});
    }

    handleClickBuy(index) {
        console.log("student clicked", this.state.open);
        var test = this.state.open;
        if(test[index]===false){
            test[index] = true;
        }
        else {
            test[index] = false;
        }
        //test[index] = !test[index];
        this.setState({open: test})

    }

    componentWillReceiveProps(nextProps, nextState){
      console.log(nextProps, nextState);
    }

    componentWillUnmount() {
        // console.log("simulationContainer componentWillUnmount");
        this.plotlyrenderRef.off();
        this.studentRef.off();
        this.statListeners.map(theRef=>{
          theRef.off();
        });
        this.props.updateTime(false);
    }

    /**
     * renders all components of the simulation here
     * based on renderplotly(bool) conditionally render plotly graph
     */
    render() {
        console.log("simulationContainer render");
        let {stepsEnabled, steps, initialStep} = this.state;
        return (
          <div className="app-sim">
            <Drawer variant="persistent" style={Object.assign({}, !this.state.showingStudents && styles.hide)} open={this.state.showingStudents} onClose={this.toggleStudents.bind(this)}>
                {/* <div style={styles.paper}>{this.state.studentsData}</div> */}
                <div>
                <List style={{
                    width:'240px',
                    margin: '0 auto',
                }} >
                    {this.state.studentsData.map((student,index)=>{ return (
                       <ListItem key={student.displayName} button>
                            <ListItemText inset primary={index + 1} />
                            <ListItemText inset primary={student.displayName} />
                            <ListItemText inset primary={this.state.displayStats[student.uid].shares} />
                            <ListItemText inset primary={this.state.displayStats[student.uid].mission} />
                        </ListItem>
                         );
                    })
                    }
                    </List>
                    {/* <List >
                        <ListItem button onClick={this.handleClickBuy.bind(this)}>
                            <ListItemText inset primary="Buy" />
                            {this.state.openBuy ? <ExpandLess /> : <ExpandMore />}
                        </ListItem>
                        <Collapse in={this.state.openBuy} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                <ListItem>
                                <ListItemText inset primary={this.state.dataItemsBuy} />
                                </ListItem>
                            </List>
                        </Collapse>
                        <ListItem button onClick={this.handleClickSell.bind(this)}>
                            <ListItemText inset primary="Sell" />
                            {this.state.openSell ? <ExpandLess /> : <ExpandMore />}
                        </ListItem>
                        <Collapse in={this.state.openSell} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                <ListItem>
                                <ListItemText inset primary={this.state.dataItemsSell} />
                                </ListItem>
                            </List>
                        </Collapse>
                    </List> */}
                </div>
            </Drawer>
            <div className="simulation-container-style" style={Object.assign({}, this.state.showingStudents && styles.shift)}>
                <div className="simulation-options-div">
                    <Button
                        uid={this.props.user.uid}
                        institution={this.props.institution}
                        sessionid={this.props.location.state.sessionid}
                        db={this.db}
                        isReady={this.state.isReady}
                    />
                    <button onClick={this.toggleStudents.bind(this)} >{this.state.showingStudents ? <span>Hide</span> : <span>Show</span>} Participants</button>
                </div>


                    <div className="total-stats-div-style simulation-box">
                        <TotalStats
                            institution={this.props.institution}
                            sessionid={this.props.location.state.sessionid}
                            db={this.db}
                            uid={this.props.user.uid}
                            dealerMode={this.props.location.state.dealerMode}
                        />
                    </div>
                    <div className="order-book-container-div-style simulation-box">
                       {this.props.location.state.dealerMode &&
                          <DealerContainer
                              institution={this.props.institution}
                              sessionid={this.props.location.state.sessionid}
                              db={this.db}
                              uid={this.props.user.uid}
                              onReady={this.handleStart.bind(this)}
                          />
                        }
                        {!this.props.location.state.dealerMode &&
                          <OrderbookContainer
                              institution={this.props.institution}
                              sessionid={this.props.location.state.sessionid}
                              db={this.db}
                              uid={this.props.user.uid}
                              onReady={this.handleStart.bind(this)}
                          />
                        }
                    </div>

                <div className="graph-div simulation-box">
                    {this.state.renderplotly
                        ?
                        <Switcher
                            institution={this.props.institution}
                            db={this.db}
                            sessionid={this.props.location.state.sessionid}
                        />
                        :
                        <div>
                            Loading 3
                            Day Sim...
                        </div>
                    }
                </div>

                <div className="simulation-log simulation-box">
                    <TransactionSwitcher
                        institution={this.props.institution}
                        sessionid={this.props.location.state.sessionid}
                        db={this.db}
                        uid={this.props.user.uid}
                    />
                </div>
            </div>
          </div>
        );
    }
}

simulationContainer.propTypes = {
    authed: PropTypes.bool,
    user: PropTypes.object,
    sessionid: PropTypes.string
};

export default simulationContainer;



// WEBPACK FOOTER //
// ./src/components/Orderbook/SimulationContainer.js